export const events = {
  analyticsCyclesFilter: 'Filter by cycle eNPS analytics',
  applyFiltersEnpsCancel: 'Apply filters eNPS cancel',
  applyFiltersEnpsStart: 'Apply filters eNPS start',
  applyFiltersEnpsSubmit: 'Apply filters eNPS submit',
  goToEnpsAnalytics: 'Go to eNPS analytics',
  goToEnpsAnswers: 'Go to eNPS answers',
  goToEnpsResults: 'Go to eNPS results',
  goToEnpsSettings: 'Go to eNPS settings',
  launchSurveyEnps: 'Launch survey eNPS',
  resetFiltersEnps: 'Reset filters eNPS',
  resultsCyclesFilter: 'Filter by cycle eNPS results',
  resumeSurveyEnps: 'Resume survey eNPS',
  saveDescriptionSettingsEnps: 'Save description settings eNPS',
  stopSurveySettingsEnps: 'Stop survey settings eNPS',
  submitEnpsAnswer: 'Submit eNPS answer',
}
